import { render, staticRenderFns } from "./SmsEdge.vue?vue&type=template&id=78da163f&scoped=true&"
import script from "./SmsEdge.vue?vue&type=script&lang=js&"
export * from "./SmsEdge.vue?vue&type=script&lang=js&"
import style0 from "./SmsEdge.vue?vue&type=style&index=0&id=78da163f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da163f",
  null
  
)

export default component.exports